import React, { useState } from 'react';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import { useUserOffices } from '../../../hooks/useUserOffices';
import LoadingSpinner from '../../common/controls/LoadingSpinner';
import VerticalHamburgerMenu from '../../common/controls/VerticalHamburgerMenu';
import Box from '@mui/material/Box';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import { useRemoveUserOffice } from '../../../hooks/useRemoveUserOffice';
import UserModules from '../modals/UserModules';
import { Typography } from '@mui/material';
import ChangeUserType from '../modals/ChangeUserType';

export default function UserOfficesList({ toggleUserListTrigger, user = null, trigger}) {

    const { t } = useTranslation('common');

    const { userOffices, loading } = useUserOffices(user.id, trigger);

    const { remove } = useRemoveUserOffice();

    const { showSnackbar } = useSnackbar();

    const [userModulesOpen, setUserModulesOpen] = useState(false);
    const [changeUserTypeOpen, setChangeUserTypeOpen] = useState(false);

    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedOffice, setSelectedOffice] = useState(null);

    const handleChangeUserType = (user, office) => {
      setSelectedUser(user);
      setSelectedOffice(office);
      setChangeUserTypeOpen(true);
    }

    const handleEditAccess = (user, office) => {
      setSelectedUser(user);
      setSelectedOffice(office);
      setUserModulesOpen(true);
    }

    const handleRemove = async (user, office) => {
        try {
            await remove(user.id, office.id);
            toggleUserListTrigger();
            showSnackbar(t('user_offices.messages.remove_success', { office: office.name, name: user.name }), "success");
        } catch (err) {
            showSnackbar(t('user_offices.messages.remove_fail', { office: office.name, name: user.name }), "error");
        }
    };

    if (loading) {
        return (
            <LoadingSpinner />
        );
    }

    return(
      <>
        <List>
            {userOffices.offices.map((office) => (
            <ListItem
                key={office.id}
                secondaryAction={
                    <Box sx={{ ml: 2, display: 'flex', alignItems: 'right' }}>
                        <VerticalHamburgerMenu 
                            options={[
                              {
                                id: 1,
                                name: 'Change Account Type',
                                callback: () => handleChangeUserType(user, office)
                              },
                              {
                                id: 2,
                                name: 'Edit Access',
                                callback: () => handleEditAccess(user, office)
                              },
                              {
                                id: 3,
                                name: 'Remove',
                                callback: () => handleRemove(user, office),
                                confirmMessage: t('user_offices.messages.remove_confirm', { name: user.name, office: office.name }),
                              },
                            ]}
                        />
                    </Box>
                }
            >
                <ListItemText 
                    // primary={`${office.name}${office.UserOffice.type}`}  
                    primary={
                      <>
                      <Typography>
                        {`${office.name}`}
                      </Typography>
                      <Typography sx={{ m: 0 }} variant='body2'>
                        account type: {`${office.UserOffice.type}`}
                      </Typography>
                      </>
                    }
                    secondary={office.company ? office.company.name : ""}
                />
            </ListItem>
            ))}
        </List>
        <UserModules
          open={userModulesOpen}
          onClose={() => setUserModulesOpen(false)} 
          user={selectedUser}
          office={selectedOffice}
        />
        <ChangeUserType 
          open={changeUserTypeOpen}
          onClose={() => setChangeUserTypeOpen(false)}
          user={selectedUser}
          office={selectedOffice}
          toggleUserListTrigger={toggleUserListTrigger}
        />
      </>
    );
}